import { useAnalyticsSkuViewedContext } from '@cc-shopping/platform-analytics/AnalyticsSkuViewed/Context';
import { usePageAction } from '@cc-shopping/platform-analytics/hooks/usePageAction';

type TooltipActionType = 'open' | 'close';

const getAnalyticsDriverActionName = (driverLabel: string) => {
  return `quick_fact_value_tooltip_${driverLabel.toLowerCase().split(' ').join('')}`;
};

export function useMonetizingTooltipPageAction() {
  const { skuImpressionId } = useAnalyticsSkuViewedContext();

  const firePageAction = usePageAction({
    actionName: '',
    additionalAttributes: {
      sku_impression_id: skuImpressionId,
    },
  });

  return (driverLabel: string, actionType: TooltipActionType, actionSection: string) => {
    firePageAction({
      action_name: `${getAnalyticsDriverActionName(driverLabel)}`,
      action_type: actionType,
      action_section: actionSection,
    });
  };
}

export function useNonMonetizingTooltipPageAction(offerId: string) {
  function getAnalyticsDriverActionName(driverLabel: string) {
    return `quick_fact_value_tooltip_${driverLabel.toLowerCase().split(' ').join('')}`;
  }

  const firePageAction = usePageAction({
    actionName: '',
    additionalAttributes: {
      sku_id: offerId,
    },
  });

  return (driverLabel: string, actionType: TooltipActionType, actionSection: string) => {
    firePageAction({
      action_name: `${getAnalyticsDriverActionName(driverLabel)}`,
      action_type: actionType,
      action_section: actionSection,
    });
  };
}
